<!--import pdfButtonRow from '@PortalVueComponents/PdfButtonRow/pdf.button.row.vue';-->
<!--'pdf-button-row-component': pdfButtonRow-->
<!--<pdf-button-row-component :key="fin-forms-bottom"
                          :is-saving-data="isSavingData"
                          :pdf-preview-url="pdfPreviewUrl"
                          :submit-button-text="cmsContentBlocks.pdfPreviewIAccept"
                          :back-button-text="cmsContentBlocks.pdfPreviewModifyForm"
                          :download-pdf-button-text="cmsContentBlocks.pdfPreviewDownloadPdf"
                          @on-submit="submitAndCommit"
                          @on-back="mode = 'EntryScreen'">
</pdf-button-row-component>-->

<template>

    <div>
        <button @click="$emit('on-submit')" :disabled="isSavingData" type="button" class="btn btn-primary col col-md-auto">
            <span v-if="isSavingData" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <div v-if="!isSavingData" class="d-inline">
                <i class="far fa-save icon-button-w-text" :aria-label="submitButtonText"></i>
            </div>{{submitButtonText}}
        </button>
        <button @click="$emit('on-back')" :disabled="isSavingData" type="button" class="btn btn-secondary col col-md-auto mt-2 mt-md-0"><i class="far fa-fw fa-edit icon-button-w-text" :aria-label="backButtonText"></i>{{backButtonText}}</button>
        <a target="_blank" :href="pdfPreviewUrl" v-bind:class="{ 'disabled': isSavingData }" class="btn btn-info col col-md-auto mt-2 mt-md-0 btn-ada-info"><i class="fa-fw far fa-download icon-button-w-text" :aria-label="downloadPdfButtonText"></i>{{downloadPdfButtonText}}</a>
    </div>

</template>

<script>

    export default {
        props: {
            isSavingData: { type: Boolean },
            pdfPreviewUrl: { type: String },

            submitButtonText: { type: String },
            backButtonText: { type: String },
            downloadPdfButtonText: { type: String }
        }
    };

</script>

